/* eslint-disable */

import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import cIf from 'classnames';

import {up} from 'ts-util';
import {OverlayWaitSpinner, AddToCartButtons, MembershipCardStatusEnum} from '../../../../jsxctl/utilctl';
import {MembershipCardPickupControl} from '../memberships'
import { defaultTo, filter, find, forEach, head, map, mapKeys, orderBy, reduce, setWith, sumBy } from 'lodash';
import { VenuePlanKit, EventDatePriceList, TicketsList, TotalFooter } from '../selectprices';

import { EventDatePriceListModel, PriceGroupModel, PriceListResponse, QuantitiesInCartAlreadyHaveThisPrice, UserCreditCardConditionModel, UserMembershipCardModel } from '../../../mvcapi/models/buyticket/ticketpriceselection';
import type { AutoFindTicketModel } from '../../../logic/models';
import { clearUnselectedTickets, getEventDatePriceList } from '../../../mvcapi/buy-ticket-api';
import { CreateReactClassComponent } from '../../../types/createreactapp';
import { toDict } from '@tsinternetsale/common';
import { AddPackageTicketsToCartResult, AddTicketsToCartResult, AddToCartPackageRequest, AddToCartRequest, AddToCartRequestType } from '../../../mvcapi/models/buyticket/ticketselection';
import { MembershipTypeSaleInfoModel } from '../../../tsrestapi/models';
import { SiteCustomizationContext } from '../../../logic/reactcontext/site-customization-context';
import { contextType } from 'react-markdown';
import type { SiteSettings } from '@tsinternetsale/common';
import { MembershipCardStatusEnumType } from '../../../logic/models/membership';
import { addItemToCartTrackingEvent } from '../../../types/models';
import { PackageInfoModel } from '../../../mvcapi/models/common/package-info-model';
import { prepareAddPackageToCartTrackingData, prepareNewAddTicketsToCartTrackingData } from '../../../logic/tracking-logic';
import { trackEcommerceEvent } from '../../../../js/client-tracking';

var modal = require('../../../../jsxctl/modal');
var guidEmpty = '00000000-0000-0000-0000-000000000000';
var tr = require('ts-translate-js').default.boundTR;
var tsRest = require('ts-rest-client');
var MarkDown = require("react-markdown");


export type PriceList = { 
    EventDates: Array<EventDatePriceListModel>
};

interface TicketPriceSelectionProps {
    packageID?: number,
    packageInfo?: PackageInfoModel, // Informational only (For addToCart tracking)
    eventDateIDs: Array<number>,
    onProductAddedToCart?: (placeToGo: string) => void,
    integ?: string,
    onContentChange?: () => void,
    onFindTicketsWhenNoPrice?: (autoFindTickets: AutoFindTicketModel) => void
}

interface TicketPriceSelectionState {
    cartItemPriceRequest: CartItemPriceRequestModel,
    creditCardMessageState: { [creditCardConditionID: string]: boolean },
    activeMembershipCards: UserMembershipCardModel[],
    selectedMembershipTypeID: number,
    membershipCardAddingSuccessfully: boolean,
    ticketsBeingAddedInCart: boolean,
    priceList: PriceListResponse,
    invalidQty: boolean,
    errorMessage?: string,
    showErrorMessage?: boolean,
    messageInvalidQty?: string,
    selectedEventDateID?: number,
    showMembercardPopup?: boolean,
    refreshQtyProcessing?: boolean,
    membershipTypeInfos?: MembershipTypeSaleInfoModel[],
    processing?: boolean,
    salesurls?: any,
    activeCreditCardConditions?: UserCreditCardConditionModel[],
    eventDatesResults?: AddTicketsToCartResult[],
    membershipCardStatus?: MembershipCardStatusEnumType,
}

type TicketPriceSelectionInterface = CreateReactClassComponent<typeof TicketPriceSelectionDef, TicketPriceSelectionProps, TicketPriceSelectionState>;

export const TicketPriceSelectionDef = {
    displayName: "TicketPriceSelection",
    
    statics: {
        contextType: SiteCustomizationContext,
    },

    PropTypes: {
        packageID: PropTypes.number,
        packageInfo: PropTypes.object, // Informational only (For addToCart tracking)
        eventDateIDs: PropTypes.array.isRequired,
        onProductAddedToCart: PropTypes.func,
        integ: PropTypes.string,
        onContentChange: PropTypes.func,
        onFindTicketsWhenNoPrice: PropTypes.func,
    },

    getInitialState() {
        return {
            cartItemPriceRequest: {},
            creditCardMessageState: { 'creditCardConditionID' : true },
            activeMembershipCards: null,
            selectedMembershipTypeID: null,
            membershipCardAddingSuccessfully: false,
            ticketsBeingAddedInCart: false,
            priceList: {} as PriceListResponse, // Should not be empty object but I'm just typescripting the file for the moment.
            invalidQty: false
        };
    },

    componentDidMount() {
        const _this: TicketPriceSelectionInterface = this;
        _this.containerRef = React.createRef();

        _this.loadPriceList();

        window.addEventListener("beforeunload", clearUnselectedTickets, true);

        if(_this.props.onContentChange != null) _this.props.onContentChange();
    },

    componentDidUpdate() {
        const _this: TicketPriceSelectionInterface = this;
        if(_this.props.onContentChange != null) _this.props.onContentChange();
    },

    componentWillUnmount() {
        const _this: TicketPriceSelectionInterface = this;
        window.removeEventListener("beforeunload", clearUnselectedTickets);
        clearUnselectedTickets();

        if(_this.membershipCardRequest != null) _this.membershipCardRequest.abort();
        if(_this.searchTicketRequest != null) _this.searchTicketRequest.abort();
        if(_this.loadPriceListRequest != null) _this.loadPriceListRequest.abort();
    },

    

    handleAddTicketsToCart(placeToGo) {
        const _this: TicketPriceSelectionInterface = this;

        _this.setState({ ticketsBeingAddedInCart: true });
        if(_this.props.packageID == null) {
            
            var eventDate: EventDatePriceListModel = _this.state.priceList.EventDates[0];
            var addToCartRequest = _this.getAddTicketRequestForEventDate(eventDate);

            tsapp.mvcapi.postCtl('buyticket/addticketstocart', addToCartRequest)
                           .success(async function() {

                                // Tracking
                                try {
                                    const trackingData = prepareNewAddTicketsToCartTrackingData(
                                        tsapp.currentCurrency, addToCartRequest, eventDate.EventDateNameFr, eventDate.EventCategoryFr, eventDate.EventDateCode, null
                                    );

                                    await trackEcommerceEvent(_this.props.integ, trackingData);
                                } catch (e) { console.log(e); }

                                if(_this.props.onProductAddedToCart != null) _this.props.onProductAddedToCart(placeToGo);
                            }.bind(_this))
                           .notSuccess(function(data) {
                               _this.setState({ ticketsBeingAddedInCart: false });

                               return _this.addTicketToCart_NotSuccess(data);
                           }.bind(_this))
                           .commError(function() {
                               _this.setState({ ticketsBeingAddedInCart: false });

                               return _this.addTicketToCart_NotSuccess({
                                   IsSuccess: false
                               }, true);
                           }.bind(_this));
        }
        else
        {
            const addToCartRequestPackage: AddToCartPackageRequest = {
                type: AddToCartRequestType.Package,
                packageID: _this.props.packageID,
                eventDates: map(_this.state.priceList.EventDates, (eventDate) => _this.getAddTicketRequestForEventDate(eventDate)),
                supportsCCCondition: true,
                supportsMembershipCondition: true,
                
                // We don't set the shipping method before adding to cart anymore.
                deliveryMethodSet: false,
                shipTicketsByMail: false, 
                shipTicketsByETicket: false,
            };

            tsapp.mvcapi.postCtl('buypackage/addticketstocart', addToCartRequestPackage)
                 .success(async function() { 
                    try {
                        const trackingData = prepareAddPackageToCartTrackingData(
                            tsapp.currentCurrency, _this.props.packageInfo, addToCartRequestPackage, _this.state.priceList
                        );

                        await trackEcommerceEvent(_this.props.integ, trackingData);
                    } catch (e) { console.log(e); }
                    if(_this.props.onProductAddedToCart != null) 
                        _this.props.onProductAddedToCart(placeToGo); 
                 }.bind(_this))
                 .notSuccess(function(data: AddPackageTicketsToCartResult) {
                     _this.setState({ ticketsBeingAddedInCart: false });
                     return _this.addPackageTicketToCart_NotSuccess(data);
                 }.bind(_this))
                 .commError(function() {
                     _this.setState({ ticketsBeingAddedInCart: false });

                     return _this.addPackageTicketToCart_NotSuccess({
                         IsSuccess: false
                     }, true);
                 }.bind(_this));
        }
	},

    getAddTicketRequestForEventDate(eventDate: EventDatePriceListModel): AddToCartRequest {
        const _this: TicketPriceSelectionInterface = this;

        var addToCartRequest = {
            type: AddToCartRequestType.EventDate,
            eventDateID: eventDate.EventDateID,
            ticketIDList: _this.getTicketIDList(eventDate),
            ticketPrices: [],
            supportsCCCondition: true,
            supportsMembershipCondition: true,
            total: 0,
            shipTicketsByMail: false,
            shipTicketsByETicket: false,
            deliveryMethodSet: false,
        };

        forEach(_this.state.cartItemPriceRequest[eventDate.EventDateID], function(price, priceid) {
            if (price != null) {
                var priceGroup = find(eventDate.PriceGroups, function(group) { return group.PriceID === parseInt(priceid); });
                if (price.qty != 0 && priceGroup != undefined) {
                    addToCartRequest.total += priceGroup.Total;
                }
                addToCartRequest.ticketPrices.push({
                    priceID : priceid,
                    ticketQuantity : price.qty
                });
            }
        });

        return addToCartRequest;
    },

    addTicketToCart_NotSuccess(result: AddTicketsToCartResult, commError: boolean = false) {
        const _this: TicketPriceSelectionInterface = this;
        if (commError)
        {
            alert(tr("general.communicationerroroccuredpleaseretry"));
        }
        else if (result.MustRedirectToCart)
        {
            alert(result.ErrorMessage);
            tsapp.goToCart(_this.props.integ);
        }
        else // Will probably never be called but in case of...
        {
            _this.setState({ showErrorMessage: true, errorMessage: result.ErrorMessage });
        }
    },

    addPackageTicketToCart_NotSuccess(result: AddPackageTicketsToCartResult, commError: boolean = false) {
        const _this: TicketPriceSelectionInterface = this;
        if (commError)
        {
            alert(tr("general.communicationerroroccuredpleaseretry"));
        }
        else if (result.MustRedirectToCart)
        {
            alert(result.ErrorMessage);
            tsapp.goToCart(_this.props.integ);
        }
        else // Will probably never be called but in case of...
        {
            _this.setState({ showErrorMessage: result.ErrorMessage != "", errorMessage: result.ErrorMessage, eventDatesResults: result.EventDatesResults });
        }
    },

    validateQtyRequest(cartItemPriceRequest: CartItemPriceRequestModel) {
        const _this: TicketPriceSelectionInterface = this;
        var qtyRequestByEventDateID = {};
        for(var eventDateID in cartItemPriceRequest) {
			qtyRequestByEventDateID[eventDateID] = reduce(cartItemPriceRequest[eventDateID], (acc, val) =>  acc + val.qty, 0);
        }
        var messageInvalidQty = null;

        forEach(_this.state.priceList.EventDates, (curEventDate) => {
            var curQty = qtyRequestByEventDateID[curEventDate.EventDateID];

            // TODO: curEventDate.EventDateName Ajouter le nom lorsque ce sera un forfait
            if(curQty < curEventDate.Tickets.length)
                messageInvalidQty = tr("ticketpriceselection.qtytotallowerthannumberofticketsreserved", { qtyrequest: curQty, nbrtickets: curEventDate.Tickets.length });
            else if(curQty > curEventDate.Tickets.length)
                messageInvalidQty = tr("ticketpriceselection.qtytotalhigherthannumberofticketsreserved", { qtyrequest: curQty, nbrtickets: curEventDate.Tickets.length });

        }
        );

        _this.setState({ invalidQty: messageInvalidQty != null, messageInvalidQty: messageInvalidQty });
    },

    handleOnMembershipTypeClick(membershipTypeID: string) {
        const _this: TicketPriceSelectionInterface = this;
        var membershipTypeIDs = [];
        membershipTypeIDs.push(membershipTypeID);

        _this.loadMembershipTypeSaleInfos(membershipTypeIDs);
    },

    handleChangeQty: function(eventDateID: number, priceList: { [priceId: number]: number}) {
        const _this: TicketPriceSelectionInterface = this;
        // We should change that for an immutable operation.

        // If special package :
        let newCartItemPriceRequest = _this.setSamePriceGroupQtyEverywhere(eventDateID, priceList, _this.state.cartItemPriceRequest); // According to price names            
        _this.setState({ cartItemPriceRequest: newCartItemPriceRequest });
        _this.validateQtyRequest(newCartItemPriceRequest);
    },

    handleCreditCardMessageSeen(creditCardConditionID) {
        const _this: TicketPriceSelectionInterface = this;
        _this.state.creditCardMessageState[creditCardConditionID] = true;
        _this.setState({creditCardMessageState: _this.state.creditCardMessageState });
    },

    handleOnEventDateSelected(eventDateID) {
        const _this: TicketPriceSelectionInterface = this;
        if(_this.state.selectedEventDateID !== eventDateID)
            _this.setState({ selectedEventDateID : eventDateID });
    },



    handlePopupClose() {
        const _this: TicketPriceSelectionInterface = this;
        _this.setState({ showMembercardPopup: false, selectedMembershipTypeID: null});
    },
    
    refreshActiveMembershipCards(membershipTypeID: string, membershipCardStatus: MembershipCardStatusEnumType) {
        const _this: TicketPriceSelectionInterface = this;
        _this.setState({ refreshQtyProcessing: true });

        _this.membershipCardRequest = tsapp.mvcapi.postCtl("membership/myactivecards", {}).success(function(data) {
            const cartItemPriceRequest = {..._this.state.cartItemPriceRequest}; 
            _this.distributeQtyToPriceGroups(_this.state.priceList.EventDates,
                                            cartItemPriceRequest,
                                            data.cards,
                                            _this.state.activeCreditCardConditions,
                                            membershipTypeID);

            forEach(_this.state.priceList.EventDates, (eventDate) => _this.refreshPriceGroups(eventDate.PriceGroups, data.cards));

            _this.setState({
                cartItemPriceRequest: cartItemPriceRequest,
                refreshQtyProcessing: false,
                priceList: _this.state.priceList,
                activeMembershipCards: data.cards,
                membershipCardStatus: membershipCardStatus,
                membershipCardAddingSuccessfully: true });


            _this.handlePopupClose();
        }.bind(_this));
    },


    refreshPriceGroups(priceGroups: PriceGroupModel[], activeMembershipCards: UserMembershipCardModel[]) {
        const _this: TicketPriceSelectionInterface = this;
        let pgsMembershipRequired = filter(priceGroups, (pg) => pg.RequiredMembershipTypeID != guidEmpty) // Ceux qui ont besoin d'une carte active
        //On active les groupes de prix si la carte devient active
        forEach(pgsMembershipRequired, (pg) => { pg.Disabled = _this.disabledPriceConditionCheck(pg, activeMembershipCards) }); // enabled le groupe de prix

    },

    resetPriceGroupQtyAfterClickToPriceName(priceName) {
        const _this: TicketPriceSelectionInterface = this;

        //On active les groupes de prix si la carte devient active
        forEach(
      	    _this.state.priceList.EventDates,
            (ed) => {
                var foundPriceGroup = find(ed.PriceGroups,
                                             (pg) => (!pg.Disabled && pg.Name == priceName));

                if(foundPriceGroup != null) {
                    var priceReqs = {};

                    // Ajoute le priceRequest de membre dans le dictionnaire par event
                    setWith(priceReqs, "[" + foundPriceGroup.PriceID + "][qty]", ed.Tickets.length, Object);

                    _this.state.cartItemPriceRequest[ed.EventDateID] = priceReqs;
                }
            });

        _this.setState({ cartItemPriceRequest: _this.state.cartItemPriceRequest });
    },

    // Lorque c'est un forfait, on veut que le choix des quantités se réflète sur toutes les dates sélectionnées
    setSamePriceGroupQtyEverywhere(srcEventDateId, srcPriceReq, cartItemPriceRequest) {
        const _this: TicketPriceSelectionInterface = this;
        // Faire un price request par price group name
        // { [eventDateId]: { [priceId]: { qty: tixQty } }
        // TODO: Make sure it can't crash because something is missing.
        
        const srcEventDate = find(_this.state.priceList.EventDates, (ed) => ed.EventDateID == srcEventDateId);

        // Convert the "qty by price id" to "qty by price name"
        const qtyByPGName = convertQtyByPGIDToQtyByPGName(srcEventDate, srcPriceReq);

        // Spread the qties in all events by price name
        let newQTYKit = cartItemPriceRequest;
        forEach(_this.state.priceList.EventDates, (dstEventDate) => {
            // Reconvert qty by name to qty by id in the context of _this current destination event date.
            const qtyByPGID = convertQtyByPGNameToQtyByPGId(dstEventDate, qtyByPGName);
            
            newQTYKit = Object.assign({}, newQTYKit, { [dstEventDate.EventDateID]: qtyByPGID });
        });

        return newQTYKit;
    },    
    
    checkPriceIsSellable(curPG: PriceGroupModel, activeMembershipCards: UserMembershipCardModel[], activeCreditCardConditions: UserCreditCardConditionModel[]) {
        const _this: TicketPriceSelectionInterface = this;

        var isSellable = curPG.IsSellable;

        if(curPG.RequiredMembershipTypeID != guidEmpty) {
            var activeMembershipCardsByTypeID = toDict(activeMembershipCards, (m => m.membershipTypeId));
            if(activeMembershipCardsByTypeID[curPG.RequiredMembershipTypeID] == null)
                isSellable = false;
        }

        if(curPG.RequiredCreditCardConditionID != guidEmpty) {
            var activeCreditCardConditionsByCreditCardID = toDict(activeCreditCardConditions, (c => c.id));
            if(activeCreditCardConditionsByCreditCardID[curPG.RequiredCreditCardConditionID] == null)
                isSellable = false;
        }

        return isSellable;
    },

    setPriceRequestQty(eventDateID: number, highestPrices: SuperPriceGroupModel[], qtyToDistribute: number, priceQuantitiesInCart: QuantitiesInCartAlreadyHaveThisPrice[], priceReqs, activeMembershipCards: UserMembershipCardModel[], activeCreditCardConditions: UserCreditCardConditionModel[]) {
        const _this: TicketPriceSelectionInterface = this;
        // Fill the supr price grid:
        for(var index in highestPrices)
        {
            var curPG = highestPrices[index];
            var nbrOfTicketsToKeepHere = qtyToDistribute;

            if (_this.checkPriceIsSellable(curPG, activeMembershipCards, activeCreditCardConditions))
            {
                var qtyByPriceID = toDict(priceQuantitiesInCart, (q => q.PriceID));

                // If needed, count the items with the same price in the cart for the MIN & MAX features.
                var ticketsInCartAlreadyHaveThisPrice = 0;
                if (curPG.HasMinOrMaxTicketPerOrder)
                    ticketsInCartAlreadyHaveThisPrice = qtyByPriceID[curPG.PriceID] ? qtyByPriceID[curPG.PriceID].QtyInCart : 0;

                // If this price has a maximum, clip the ticket quantity to the max of the price group.
                // This also considers ticket already in the cart!
                if (curPG.IsMaxTicketPerOrderActivated)
                {
                    // MAX(2) - PANIER(1) = ACCEPT(1)
                    var qtyAccepted = curPG.MaxTicketPerOrder - ticketsInCartAlreadyHaveThisPrice;

                    // Clip au ACCEPT : Si DEMANDE(2) > ACCEPT(1) then KEEP = ACCEPT(1) else KEEP = DEMANDE(2)
                    nbrOfTicketsToKeepHere = (nbrOfTicketsToKeepHere > qtyAccepted) ? qtyAccepted : nbrOfTicketsToKeepHere;
                }

                // If this price has a minimum:
                if (curPG.IsMinTicketPerOrderActivated)
                {
                    // Si la quantité demandée + la quantité déjà dans le panier reste en dessous du minimum, on accepte pas!
                    // L'addition des item déjà dans le panier est très importante pour le cas suivant :
                    //  1) Disons nous avons un minimum de 4
                    //  2) La personne ajoute une première fois 4 billet, le minimum est respecté et ça fonctionne
                    //  3) La personne veut ajouter un billet à tout ça, 1 billet ne passerait normalement pas dans la validation mais 1(nouveau) + 4(panier) = 5 donc on accept typese!
                    nbrOfTicketsToKeepHere = ((nbrOfTicketsToKeepHere + ticketsInCartAlreadyHaveThisPrice) < curPG.MinTicketPerOrder) ? 0 : nbrOfTicketsToKeepHere;
                }

                if (curPG.IsRequiredTicketQTYMultipleOfActivated)
                {
                    // Check and returns the accepTed ticket qty for this price group.
                    nbrOfTicketsToKeepHere = nbrOfTicketsToKeepHere - (nbrOfTicketsToKeepHere % curPG.RequiredTicketQTYMultipleOf);
                }
            }
            else
                nbrOfTicketsToKeepHere = 0;

            qtyToDistribute = qtyToDistribute - nbrOfTicketsToKeepHere;

            // Ajoute le priceRequest de membre dans le dictionnaire par event
            setWith(priceReqs, "[" + eventDateID + "][" + curPG.PriceID + "][qty]", nbrOfTicketsToKeepHere, Object);

            if(qtyToDistribute == 0)
                break;
        }

    },

    distributeQtyToPriceGroups(eventDates: EventDatePriceListModel[], priceReqs, activeMembershipCards: UserMembershipCardModel[], activeCreditCardConditions: UserCreditCardConditionModel[], membershipTypeID: string | number) {
        const _this: TicketPriceSelectionInterface = this;
        for(var index in eventDates) {

            var priceGroupsToDistributeQty = null;

            var curEventDate = eventDates[index];

            if(curEventDate.PriceGroups.length > 0) {
                var curEventDatePriceReqs = priceReqs[curEventDate.EventDateID];

                if(curEventDatePriceReqs == null)
                    curEventDatePriceReqs = {};

                var qtyToDistribute = curEventDate.Tickets.length;

                // Associe les priceRequest aux PGs
                var superPGs = _this.associatePriceReqsAndDef(curEventDate.PriceGroups, curEventDatePriceReqs);

                // Trouver le meilleur prix selon les cartes actives
                var bestPrice = _this.getBestPriceToDistribute(superPGs, activeMembershipCards, activeCreditCardConditions, membershipTypeID);

                if(bestPrice != null && !bestPrice.IsSoldOut) {
                    // priceReq plus grand que le prix membre sélectionné
                    var highestPrices = filter(superPGs, (sp) => sp.PriceID != bestPrice.PriceID && sp.Total >= bestPrice.Total);

                    //On enleve les quantité des prix qui sont plus haut que le prix membre
                    forEach(
      	                filter(highestPrices, (pg) => pg.priceRequest != null) // Ceux qui ont des price request
      	                , (pg) => pg.priceRequest.qty = 0); // Vide la quantité


                    // Calcule la quantité qu'il y a dans les tarifs plus petit qu'on ne touche pas
                    var lowestPriceTotalQty = _this.getSuperPriceGroupTotalQty(
                        filter(superPGs, (sp) => sp.Total < bestPrice.Total)
                    );                    

                    // La quantité à distribuer dans le prix membre
                    qtyToDistribute = qtyToDistribute - lowestPriceTotalQty;

                    //ajouter le bestprice en premier
                    highestPrices.unshift(bestPrice);

                    priceGroupsToDistributeQty = highestPrices;
                }
                else
                    priceGroupsToDistributeQty = superPGs;

                _this.setPriceRequestQty(curEventDate.EventDateID,
                                        priceGroupsToDistributeQty,
                                        qtyToDistribute,
                                        curEventDate.PriceQuantitiesInCart,
                                        priceReqs,
                                        activeMembershipCards,
                                        activeCreditCardConditions
                );
            }
        }

        //_this.setState({ cartItemPriceRequest: priceReqs });
    },

    getBestPriceToDistribute(superPGs: SuperPriceGroupModel[], activeMembershipCards: UserMembershipCardModel[], activeCreditCardConditions: UserCreditCardConditionModel[], membershipTypeID: number | string) {
        const _this: TicketPriceSelectionInterface = this;
        var bestPrice = null;

        // Check si on a des cartes actives
        if(activeMembershipCards.length > 0 || activeCreditCardConditions.length > 0) {
            var activeMembershipCardsByTypeID = toDict(activeMembershipCards, (m => m.membershipTypeId));
            var activeCreditCardConditionsByCreditCardID = toDict(activeCreditCardConditions, (c => c.id));

            var bestPrices = null;

            if(membershipTypeID != 0 && activeMembershipCardsByTypeID[membershipTypeID] != null) {
                // sort les prices group membership qui vient d'être activé
                bestPrices = filter(superPGs, (p) => p.RequiredMembershipTypeID == membershipTypeID);

            }
            else
            {

                bestPrices = filter(superPGs, (p) => (p.RequiredMembershipTypeID != guidEmpty && activeMembershipCardsByTypeID[p.RequiredMembershipTypeID] != null)
                                                 || (p.RequiredCreditCardConditionID != guidEmpty && activeCreditCardConditionsByCreditCardID[p.RequiredCreditCardConditionID] != null));
            }

            bestPrice = head(orderBy(bestPrices, ["Total"])); // Head: Prendre le meilleurs prix
        }

        return bestPrice;
    },

    getSuperPriceGroupTotalQty(pgs: SuperPriceGroupModel[]) {
        const _this: TicketPriceSelectionInterface = this;
	    return reduce(pgs, (acc, val) =>  acc + (val.priceRequest != undefined ? val.priceRequest.qty : 0) ,0)
    },

    associatePriceReqsAndDef(priceDefs: PriceGroupModel[], priceReqs): SuperPriceGroupModel[] {
        const _this: TicketPriceSelectionInterface = this;
	    return map(priceDefs, (obj) => {
                if(priceReqs)
                    return up(obj, { priceRequest: { $set: priceReqs[obj.PriceID] } });
                else
                    return obj;
        });
    },

    // Se désactive si c'est un groupe de prix qui requiert une carte de membre
    // Si l'achat d'une carte est au panier ou qu'on a une carte valide le prix s'active
    disabledPriceConditionCheck(price: PriceGroupModel, activeMembershipCards: UserMembershipCardModel[]) {
        const _this: TicketPriceSelectionInterface = this;
        if(price.RequiresMembership) {
            var activeMembershipCardsByTypeID = toDict(activeMembershipCards, (m => m.membershipTypeId));
            console.log(activeMembershipCardsByTypeID);
            if(activeMembershipCardsByTypeID[price.RequiredMembershipTypeID])
                return false;

            return true;
        }

        return false; // prix actif par défaut!!
    },

    getAllTotal(siteSettings: SiteSettings) {
        const _this: TicketPriceSelectionInterface = this;
        var yourTotal = 0;
        var savingPriceByMembershipTypeID: MembershipTypeSaleInfoModel[] = [];

        if(_this.state.priceList != null && _this.state.cartItemPriceRequest != null) {
            forEach(_this.state.priceList.EventDates,
                      function(curEventDate) {
                          var curEventDatePriceReqs = _this.state.cartItemPriceRequest[curEventDate.EventDateID];
                          if(curEventDatePriceReqs != null) {

                              // Associe les priceRequest aux PGs
                              var superPGs = _this.associatePriceReqsAndDef(curEventDate.PriceGroups, curEventDatePriceReqs);

		                      // On filtre les prix membres
		                      var memberPGs = filter(superPGs, (pg) => pg.RequiredMembershipTypeID != guidEmpty)

                              // Calcul de la quantity présente dans les textbox
                              var selectedQty = _this.getSuperPriceGroupTotalQty(superPGs)

                              // Total de toutes les priceRequest de la date d'ï¿½vï¿½nement
		                      var total = reduce(
    	                          filter(superPGs, (p) => p.priceRequest != null),
				                  (acc, val) => acc + ((siteSettings.taxesOnlyAtCheckout ? val.TotalBeforeTaxes : val.Total) * val.priceRequest.qty) ,0);

                              if(memberPGs.length > 0) {
    	                          // On ajoute la diffï¿½rence dans chaque membership type
                                  forEach(memberPGs, (pg) => {
                                      var membershipTotal = savingPriceByMembershipTypeID[pg.RequiredMembershipTypeID];
                                      if(membershipTotal == null) {
                                          membershipTotal = {};
                                          membershipTotal.saving = 0;
                                          membershipTotal.membershipTypeInfo = pg.MembershipTypeSaleInfo;
                                          savingPriceByMembershipTypeID[pg.RequiredMembershipTypeID] = membershipTotal;
                                      }
                                      membershipTotal.saving += (total - ((siteSettings.taxesOnlyAtCheckout ? pg.TotalBeforeTaxes : pg.Total) * selectedQty));
                                  });
                              }
                          }
                      }.bind(_this));

            var yourCumul = reduce(_this.state.priceList.EventDates,
                        (acc, val) => {
                                return reduce(_this.associatePriceReqsAndDef(val.PriceGroups, _this.state.cartItemPriceRequest[val.EventDateID]),
                                            (acc, val) => {
                                                acc.fees = acc.fees + (val.priceRequest != undefined ? val.priceRequest.qty * (siteSettings.taxesOnlyAtCheckout ? val.FeesBeforeTaxes : val.Fees) : 0);
                                                acc.total = acc.total + (val.priceRequest != undefined ? val.priceRequest.qty * (siteSettings.taxesOnlyAtCheckout ? val.TotalBeforeTaxes : val.Total) : 0);
                                                return acc;
                                            }, acc);
                        }, {fees: 0, total: 0});
        }

        return {yourCumul: yourCumul, membershipTypeSaleInfos: savingPriceByMembershipTypeID };
    },

    // Load Urls for continue sales process
    loadSalesUrls(props) {
        const _this: TicketPriceSelectionInterface = this;
        _this.setState({ processing: true });

        var urlsLoaded = _this.itemRequest = tsRest.get("integration/"+ _this.props.integ + "/urls");
        urlsLoaded
            .finally(function() { _this.setState({ processing : false }); }.bind(_this))
            .done(function (data) {
                _this.setState({ salesurls: data });
            }.bind(_this), tsRest.handleError);
    },

    getTicketIDList: (eventDate) => map(eventDate.Tickets, (t) => t.TicketID).join(';'),

    async loadPriceList() {
        const _this: TicketPriceSelectionInterface = this;
        _this.setState({ processing: true });
        
        try{
            const priceListResult = await getEventDatePriceList(_this.props.eventDateIDs, _this.props.packageID);
            _this.loadPriceList_Success(priceListResult)
        } catch(err){
        }

        _this.setState({ processing: false });
    },

    /**
     * 
     * @param {import("./ticketpriceselection").PriceListResponse} data 
     */
    loadPriceList_Success(data: PriceListResponse) {
        const _this: TicketPriceSelectionInterface = this;
        var defaultPriceRequest = {};
        
        if(_this.state.selectedEventDateID == undefined && data.EventDates.length > 0) {
            var selectedDate = data.EventDates[0];

            // Find first event date with a venue plan
            var firstEventDateWithVenuePlan = find(data.EventDates, (eventDate) => eventDate.VenuePlanInfo.planAvailable);
            if(firstEventDateWithVenuePlan != null)
                selectedDate = firstEventDateWithVenuePlan;

            _this.setState({ selectedEventDateID: selectedDate.EventDateID });
        }

        _this.distributeQtyToPriceGroups(data.EventDates, defaultPriceRequest, data.activeMembershipCards, data.activeCreditCardConditions, 0);

        forEach(data.EventDates, (eventDate) => _this.refreshPriceGroups(eventDate.PriceGroups, data.activeMembershipCards));

        // Remplir activeMembershipCards
        _this.setState({ cartItemPriceRequest: defaultPriceRequest, priceList: data, activeMembershipCards: data.activeMembershipCards, activeCreditCardConditions: data.activeCreditCardConditions });
    },

    loadMembershipTypeSaleInfos(membershipTypeIDs: string[]) {
        const _this: TicketPriceSelectionInterface = this;
        var membershipTypeSaleInfosLoadedReq = [];

        forEach(membershipTypeIDs, (membershipTypeID) =>
            membershipTypeSaleInfosLoadedReq.push(tsRest.get("membershiptypes/" + membershipTypeID + "/saleinfo", { async: false, noCache: true })));

        Promise.all(membershipTypeSaleInfosLoadedReq)
          .finally(function() { _this.setState({processing:false}); }.bind(_this))
          .then(function(membershipInfos: MembershipTypeSaleInfoModel[]) {
              _this.setState({membershipTypeInfos: membershipInfos, showMembercardPopup:true});
          }.bind(_this), tsRest.handleError);
    },

    render() {
        const _this: TicketPriceSelectionInterface = this;
        const { siteSettings } = this.context;
        var priceListContent = null;
        var membershipSelectorPopup = null;
        var isInMultiEventMode = _this.props.packageID != null;

        if(_this.state.priceList.EventDates != null) {
            var pricesList = [];
            var ticketsList = null;
            var footer = null;
            
            forEach(_this.state.priceList.EventDates, (eventDate, i) => {
                pricesList.push(
                    <EventDatePriceList 
                        key={"eventDate" + eventDate.EventDateID}
                        integ={_this.props.integ}
                        isTicketQtyDistributionReadonly={i != 0}
                        packageKit={ { 
                            packageID: _this.props.packageID, 
                            eventDateIDs: _this.props.eventDateIDs, 
                            showOnlyWholePricesOnInternet: _this.state.priceList.ShowOnlyWholePricesOnInternet 
                        } }
                        eventDate={eventDate}
                        eventDatePriceRequest={_this.state.cartItemPriceRequest[eventDate.EventDateID]}
                        selected={eventDate.EventDateID == _this.state.selectedEventDateID}
                        onChange={_this.handleChangeQty}
                        onEventDateSelected={_this.handleOnEventDateSelected}
                        afterSearchTickets={_this.loadPriceList}
                        processing={_this.state.processing}
                        hasCreditCardMessageSeen={_this.handleCreditCardMessageSeen}
                        creditCardMessageState={_this.state.creditCardMessageState}
                        resetPriceGroupQtyAfterClickToPriceName={_this.resetPriceGroupQtyAfterClickToPriceName}
                        onMoreInformationsClick={_this.handleOnMembershipTypeClick}
                        onFindTicketsWhenNoPrice={_this.props.onFindTicketsWhenNoPrice}
                        onContentChange={_this.props.onContentChange}
                        eventDateResult={find(_this.state.eventDatesResults, (eventDateResult) => eventDateResult.EventDateID == eventDate.EventDateID)} 
                    />);
            });

            // Kit de buttons utilisé partout
            var buttons = <AddToCartButtons
                              processing={_this.state.ticketsBeingAddedInCart}
                              onAddToCart={_this.handleAddTicketsToCart}
                              disabled={_this.state.invalidQty}>
            </AddToCartButtons>;

            var selectedEventDate = (!isInMultiEventMode || _this.state.selectedEventDateID == null)
                                  ? _this.state.priceList.EventDates[0]
                                  : find(_this.state.priceList.EventDates, (d) => d.EventDateID == _this.state.selectedEventDateID);

            var planCtl = null;
            if(selectedEventDate != null && !isInMultiEventMode && selectedEventDate.ProductType == "Ticket") {
                ticketsList = (
                    <div className="col-xs-12">
                        <TicketsList tickets={selectedEventDate.Tickets} eventDateID={selectedEventDate.EventDateID} onContentChange={_this.props.onContentChange}></TicketsList>
                    </div>);

                if(selectedEventDate.VenuePlanInfo.planAvailable)
                    planCtl = <VenuePlanKit selectedEventDate={selectedEventDate} afterSearchTickets={_this.loadPriceList} processing={_this.state.processing}></VenuePlanKit>;
            }

            if(_this.state.showMembercardPopup) {
                membershipSelectorPopup =
                <modal.EmptyBox integ={_this.props.integ}
                                width="78%"
                                size="sm"
                                onClose={_this.handlePopupClose}MembershipTypeSaleInfoModel
                                style={{ marginTop: "2px" }}
                                container={_this.containerRef.current}>
                            <div className="contentPanel">
                                <MembershipCardPickupControl 
                                    membershipTypeInfos={_this.state.membershipTypeInfos} 
                                    refreshActiveMembershipCards={_this.refreshActiveMembershipCards} 
                                    onContentChange={_this.props.onContentChange}
                                    showAlreadyMemberSection={true}
                                />
                            </div>
                    </modal.EmptyBox>;
            }

            var footerTotal = _this.getAllTotal(siteSettings);
            footer = <TotalFooter membershipTypeSaleInfos={footerTotal.membershipTypeSaleInfos} yourCumul={footerTotal.yourCumul} onMembershipTypeClick={_this.handleOnMembershipTypeClick} />;
            
            var errorMessage = null;
            if(_this.state.showErrorMessage)
                errorMessage = <div className="alert alert-danger">{_this.state.errorMessage}</div>;

            var membershipCardAddedMessage = null;
            if(_this.state.membershipCardAddingSuccessfully) {
                var messageMembershipCardStatus = (_this.state.membershipCardStatus == MembershipCardStatusEnum.NewCard
                                                 ? tr("ticketpriceselection.membershipcardaddingsuccessfully")
                                                 : tr("ticketpriceselection.membershipcardhasbeenfoundsuccessfully"))

                membershipCardAddedMessage = <div className="alert alert-info">{messageMembershipCardStatus}</div>;
            }

            var overlayWait = null;
            if(_this.state.refreshQtyProcessing)
                overlayWait = <OverlayWaitSpinner size="xl"></OverlayWaitSpinner>;

            var messageInvalidQty = null;
            if(_this.state.messageInvalidQty != null)
                messageInvalidQty = <div className="alert alert-danger text-right"><MarkDown source={_this.state.messageInvalidQty} /></div>;

            priceListContent = (
                <div className="ticketPrice">
                    <div className="row">
                        <br/>
                        {ticketsList}

                        {planCtl}
                        <div className={cIf({ "col-xs-12": planCtl == null,
                                              "col-lg-8 col-sm-12 col-xs-12": planCtl != null })}>
                            <div className="containerForOverlay">

                                {pricesList}

                                {overlayWait}

                                {messageInvalidQty}

                                {footer}
                            </div>
                            {membershipCardAddedMessage}

                            {errorMessage}

                            {buttons}

                        </div>
                    </div>

                    </div>
            );
        }

        return (
            <div className={_this.props.integ}>
            	{priceListContent}
                <div ref={_this.containerRef} />
            	{membershipSelectorPopup}
            </div>
        );
    }
}
export const TicketPriceSelection = createClass<TicketPriceSelectionProps, TicketPriceSelectionState>(TicketPriceSelectionDef);


export type SuperPriceGroupModel = PriceGroupModel & { priceRequest: { qty: number } };

export type PriceRequest = { qty: number };

export type CartItemPriceRequestModel = {
    [eventDateID: number]: {
        [priceID: number]: PriceRequest;
    };
}


// Logic
function convertQtyByPGIDToQtyByPGName(ed: EventDatePriceListModel, qtyByPGID: {[priceId: number]: PriceRequest}) {
    // Takes: { [priceId]: { qty: tixQty } ]
    // Return [ [priceGroupName]: { qty: tixQty } ]
    // ed.PriceGroups.Name
    return mapKeys(qtyByPGID, (qty, pgid: any) => { // TODO: Fix this type script any
        const pg = find(ed.PriceGroups, (pg) => pg.PriceID == pgid);
        return pg.Name;
    });
}

function convertQtyByPGNameToQtyByPGId(dstEd, qtyByPGName) {
    // Takes: { [priceId]: { qty: tixQty } ]
    // Return [ [priceGroupName]: { qty: tixQty } ]
    // ed.PriceGroups.Name
    return mapKeys(qtyByPGName, (qty, name) => {
        const pg = find(dstEd.PriceGroups, (pg) => pg.Name == name);
        return pg.PriceID;
    });
}


